import React, { useEffect, useState } from 'react'
import Modal from '../../../Components/ExtraComponents/Modal';
import { useFormik } from 'formik';
import * as  valid_err from "../../../Utils/Common_Messages"
import Formikform1 from "../../../Components/ExtraComponents/Form/Formik_form1"
import { useDispatch, useSelector } from "react-redux";
import { Update_smtp_details, RemoveImagebycompany } from '../../../ReduxStore/Slice/Admin/SystemSlice';
import toast from 'react-hot-toast';
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";


const UpdateImages = ({ showModal, setshowModal, data }) => {

    const dispatch = useDispatch();

    const user_token = JSON.parse(localStorage.getItem('user_details')).token;

    useEffect(() => {
        formik.setFieldValue('logo', data.length > 0 && data[0].logo);
        formik.setFieldValue('favicon', data.length > 0 && data[0].favicon);
        formik.setFieldValue('watermark', data.length > 0 && data[0].watermark);
        formik.setFieldValue('loginimg', data.length > 0 && data[0].loginimage);
        formik.setFieldValue('landing_image', data.length > 0 && data[0].landing_image);
        formik.setFieldValue('loader_image', data.length > 0 && data[0].loader_image);
    }, [data && data]);


    const formik = useFormik({
        initialValues: {
            logo: '',
            favicon: '',
            watermark: '',
            loginimg: '',
            landing_image: '',
            loader_image: '',
        },
        touched: {
            logo: '',
            favicon: '',
            watermark: '',
            loginimg: '',
            landing_image: '',
            loader_image: '',
        },
        validate: (values) => {

            const errors = {};
            // if (!values.licence) {
            //     errors.licence = valid_err.USERNAME_ERROR;
            // }
            return errors;
        },
        onSubmit: async (values) => {


            const req = {
                "id": data.length > 0 && data[0]._id,
                data: {
                    "logo": values.logo,
                    "favicon": values.favicon,
                    "watermark": values.watermark,
                    "loginimage": values.loginimg,
                    "landing_image": values.landing_image,
                    "loader_image": values.loader_image,
                }
            }
            await dispatch(Update_smtp_details({ req: req, token: user_token })).unwrap().then((response) => {

                if (response.status === 409) {
                    toast.error(response.data.msg);
                }
                else if (response.status) {
                    toast.success(response.msg);
                    setshowModal(false)

                }
                else if (!response.status) {
                    toast.error(response.msg);
                }

            })
        }
    });


    const fields = [
        { name: 'logo', label: 'Logo', type: 'file', label_size: 12, col_size: 6, disable: false },
        { name: 'favicon', label: 'Favicon', type: 'file', label_size: 12, col_size: 6, disable: false },
        { name: 'watermark', label: 'Water Mark', type: 'file', label_size: 12, col_size: 6, disable: false },
        { name: 'loginimg', label: 'Login Image', type: 'file', label_size: 12, col_size: 6, disable: false },
        { name: 'landing_image', label: 'Landing Page Image', type: 'file', label_size: 12, col_size: 6, disable: false },
        { name: 'loader_image', label: 'Loader Image', type: 'file', label_size: 12, col_size: 6, disable: false, default_img: 'https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-3d-icon-png-download-12385354.png' },


    ];



    return (
        <div>   <Modal isOpen={showModal} size="lg" title="Update Images" hideBtn={true}
            handleClose={() => setshowModal(false)}>

            <Formikform1 fieldtype={fields.filter(field => !field.showWhen || field.showWhen(formik.values))} formik={formik} btn_name="Update"
                showImagePreview={true} removebtn={false}
            />
            <ToastButton />

        </Modal ></div>
    )
}

export default UpdateImages